// @flow
import * as React from 'react';

/**
 * Chevron Left svg
 *
 * @param props
 * @return {XML}
 */
export default (props: {}) => {
    return (
        <svg width="76" height="132" viewBox="0 0 76 132" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M74 2L2.00001 69L74 130" stroke="#4F4F4F" strokeWidth="6" strokeLinejoin="round"/>
        </svg>
    );
};
